import api from '../../services/api';

export const requestPasswordReset = (email) => api.forgotPassword(email.trim());

export const submitNewPassword = ({ token, password, confirmPassword }) => {
  if (!token) throw new Error('This password reset link is invalid.');
  if (password.length < 8) throw new Error('Password must be at least 8 characters.');
  if (password !== confirmPassword) throw new Error('Passwords do not match.');
  return api.resetPassword(token, password);
};
